import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type MicIconProps = Partial<SVGIconProps>;

const MicIcon: FC<MicIconProps> = (props) => (
  <SVGIcon {...props} fill="none" viewBox="0 0 20 20">
    <path
      d="M10 12.5c1.38 0 2.5-1.12 2.5-2.5V6a2.5 2.5 0 1 0-5 0v4c0 1.38 1.12 2.5 2.5 2.5Z"
      fill="currentColor"
    />
    <path
      d="M5.5 9.75a.75.75 0 0 0-1.5 0 6 6 0 0 0 5.25 5.96V17.5a.75.75 0 1 0 1.5 0v-1.79A6 6 0 0 0 16 9.75a.75.75 0 0 0-1.5 0 4.5 4.5 0 1 1-9 0Z"
      fill="currentColor"
    />
  </SVGIcon>
);

export default MicIcon;
